import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { ConfirmationModalContext } from "../../../fautures/ConfirmationModalProvider";
import { useFetchWithToken } from "../../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../../Constants/AuthProvider";
import { apiUrl } from "../../../Constants/Constants";
import BtnToAction from "./BtnToAction.module";
const ConfigRenew = ({ item, loadingShower, getInfo }) => {
  const { onLogout } = React.useContext(AuthContext);
  const { loading, fetchWithToken } = useFetchWithToken();
  useEffect(() => {
    loadingShower(loading);
  }, [loading]);
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = React.useContext(ConfirmationModalContext);
  const createNewConfig = () => {
    const former = new FormData();
    former.append("accountid", item.id);

    fetchWithToken(
      apiUrl + "user/destroy-access",
      { method: "POST" },
      former
    ).then((data) => {
      closeModal();
      if (data.status === "200") {
        toast.success(data.data);

        getInfo();
      } else if (data.status === "6") {
        toast.error(data.data);
      }
      if (data.status === "401") {
        onLogout();
      }
    });
  };
  const createNewAccessConfig = () => {
    confirmTitle("ایجاد کانفیگ جدید؟");
    openUpModal();

    description(
      <>با ایجاد کانفیگ جدید، کانفیگ فعلی این اکانت غیر فعال میگردد.</>
    );

    toDo(() => createNewConfig);
    payloadConfirm("");
  };

  return (
    <BtnToAction
      icon="fal fa-arrows-rotate-reverse"
      action={() => createNewAccessConfig()}
    >
      کانفیگ جدید
    </BtnToAction>
  );
};

export default ConfigRenew;
